import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    step: {
        pending: {
            redirectButtonText: string,
        },
    },
    optIn: string,
};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    verificationPurposesOnly: '(Used for verification purposes only)',
    postalCodeExplanation: '(Use the location on file with your licensing body)',
    emailExplanation: '(Needed to send you your unique code)',
    statusPlaceholder: 'Status',
    organizationPlaceholder: 'Organization',
    firstNamePlaceholder: 'First name',
    lastNamePlaceholder: 'Last name',
    postalCodePlaceholder: 'Postal code',
    emailAddressPlaceholder: 'Email address',
    verifyMyMedicalProfessionalStatus: 'Verify my medical professional status',
    infoShared1: ' ',
    infoShared2: ' ',
    optIn: 'By checking this box and clicking ‘Verify my medical professional status,’ you consent to the use of your personal information, including your name and address, only for identity verification purposes. Your information will be verified by our service provider SheerID, and may be processed and stored in the United States. Your information will be collected and managed under Happiest Baby Privacy Agreement and SheerID’s <a href="https://www.sheerid.com/privacy-policy/">privacy policy</a>. We will never sell your information or use or disclose your information for marketing purposes.',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.<br><br>',
    step: {
        personalInfo: {
            title: 'Unlock this medical professional-only offer for 40% off purchase of SNOO bassinet',
            howDoesVerifyingWorkDetails: 'To be eligible for this offer, you must (1) be a currently licensed medical professional and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status selector of this form.<br><br>Happiest Baby uses SheerID, a trusted partner, to verify that you are a medical professional. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested',
        },
        docUpload: {
            title: 'We need more information',
            subtitle: 'Documents will be reviewed in 72 hours by staff at SheerID, a trusted partner.',
            submitButtonLabel: 'Submit',
            uploadInstructions: 'Upload your government-issued document that shows:',
        },
        pending: {
            titleReview: 'Processing',
            redirectButtonText: 'Continue to Happiest Baby',
            subtitle: 'SheerID is reviewing your documents, to confirm your status.<br><br><br>This process may take up to 72 hours.'
        },
        success: {
            redirectButtonText: 'Shop Now',
        },
    },
};
